import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router";
import { UseMe } from "../../api/users/Me.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import {
  AuthContext,
  AuthContextDispatchContext,
} from "../../context/auth/AuthContext";

const ProfileContainer = ({ children }) => {
  const history = useHistory();
  const { token } = useContext(AuthContext);
  const { deleteToken } = useContext(AuthContextDispatchContext);
  const { content, error, loading } = UseMe(token);

  useEffect(() => {
    if (error) {
      deleteToken();
      history.push("/");
    }
  }, [error, deleteToken, history]);

  return (
    <>
      {error ? <Error message={error} /> : null}
      {loading ? <Loading /> : null}
      {children({ content })}
    </>
  );
};

export default ProfileContainer;
